module.exports = {"220582001":"团结街道","220582002":"黎明街道","220582003":"通胜街道","220582004":"城东街道","220582100":"青石镇","220582101":"榆林镇","220582102":"花甸镇","220582103":"头道镇","220582104":"清河镇","220582105":"台上镇","220582106":"财源镇","220582107":"大路镇","220582108":"太王镇","220582200":"麻线乡","220582201":"凉水朝鲜族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220582.json
// module id = 734
// module chunks = 0